import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "voice-shell" }
const _hoisted_2 = { class: "voice-header" }
const _hoisted_3 = { class: "voice-header-main" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = {
  key: 1,
  class: "voice-initials"
}
const _hoisted_6 = { class: "voice-title-wrap" }
const _hoisted_7 = { class: "voice-title" }
const _hoisted_8 = { class: "voice-subtitle" }
const _hoisted_9 = { class: "voice-header-actions" }
const _hoisted_10 = { class: "voice-chip-row" }
const _hoisted_11 = { class: "voice-spec-grid" }
const _hoisted_12 = { class: "voice-spec" }
const _hoisted_13 = { class: "voice-spec-v voice-spec-v-mono" }
const _hoisted_14 = { class: "voice-spec" }
const _hoisted_15 = { class: "voice-spec-v" }
const _hoisted_16 = { class: "voice-spec" }
const _hoisted_17 = { class: "voice-spec-v" }
const _hoisted_18 = { class: "voice-spec" }
const _hoisted_19 = { class: "voice-spec-v" }
const _hoisted_20 = { class: "voice-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "voice-desktop-card",
    color: "background",
    variant: "elevated",
    elevation: "4",
    onClick: _ctx.emitEdit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_v_avatar, {
              size: "48",
              rounded: "lg",
              style: _normalizeStyle({ backgroundColor: _ctx.brandColor }),
              class: "voice-avatar"
            }, {
              default: _withCtx(() => [
                (_ctx.showStandaloneIcon)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: _ctx.iconSrc,
                      alt: `${_ctx.voice.providerKey} icon`,
                      class: "voice-avatar-image",
                      onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onIconError && _ctx.onIconError(...args)))
                    }, null, 40, _hoisted_4))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.voiceInitials), 1))
              ]),
              _: 1
            }, 8, ["style"]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.voice.name), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.subtitleText), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_v_tooltip, {
              text: "Edit Voice",
              location: "top"
            }, {
              activator: _withCtx(({ props }) => [
                _createVNode(_component_v_btn, _mergeProps(props, {
                  color: "primary",
                  icon: "mdi-pencil-outline",
                  size: "small",
                  variant: "plain",
                  onClick: _withModifiers(_ctx.emitEdit, ["stop"])
                }), null, 16, ["onClick"])
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.labelValues, (label) => {
            return (_openBlock(), _createBlock(_component_v_chip, {
              key: label,
              size: "small",
              variant: "tonal",
              class: "voice-chip"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(label), 1)
              ]),
              _: 2
            }, 1024))
          }), 128)),
          (_ctx.voice.responseFormat)
            ? (_openBlock(), _createBlock(_component_v_chip, {
                key: 0,
                size: "small",
                variant: "outlined",
                class: "voice-chip"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.voice.responseFormat), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "voice-spec-k" }, "Provider Voice", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.voice.providerVoiceName || _ctx.voice.voiceId), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "voice-spec-k" }, "Description", -1)),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.voice.description || _ctx.subtitleText), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "voice-spec-k" }, "Format", -1)),
            _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.voice.responseFormat || 'Default'), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "voice-spec-k" }, "Speed", -1)),
            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.speedLabel), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(_component_v_btn, {
            class: "voice-edit-btn",
            color: "primary",
            variant: "outlined",
            onClick: _withModifiers(_ctx.emitEdit, ["stop"])
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" Edit ")
            ])),
            _: 1,
            __: [5]
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onClick"]))
}